export class GroupeChantantModel {
  code: string='';
  nom: string='';
  color: string='';
  imagePath: string='';
  imagePathUrl: string='';
  imagePathBase64: string='';
  bannerTopPath: string='';
  bannerTopPathUrl: string='';
  bannerTopPathBase64: string='';

  id: string='';
  nomWithOutBreak: string='';
  isCE:boolean = false;
  isShow:boolean = false;
  cssClass: string='';

  // get codeNom(): string {
  //   return `${this.code} - ${this.nom}`;
  // }
}

export class GroupeChantantDto{
  groupeCEList: GroupeChantantModel[]=[];
  groupeCEEBVList: GroupeChantantModel[]=[];
}

export enum GroupeChantantTextField {
  title= 'Group CE',
  code= 'Code',
  imagePath= 'logo',
  nom= 'Name',
}
export const groupeChantantVIDE = {
  code: '',
  nom: '- All Group -',
  imagePath: '',
  color: '',
  imagePathUrl: './assets/images/ccg/imgchantesperance.png',

  id: '',
  nomWithOutBreak: '',
  isCE: false,
  isShow: false,
  cssClass: '',

  imagePathBase64: '',
  bannerTopPath: '',
  bannerTopPathUrl: '',
  bannerTopPathBase64: '',

  // get codeNom(): string {
  //   return (this.code!='')?`${this.code} - ${this.nom}`:`${this.nom}`;
  // }
}
